import React, { useState } from 'react';
import { ChartBarIcon, DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import ConversationExport from '../components/Analytics/ConversationExport';

const Analytics = () => {
  const [activeTab, setActiveTab] = useState('conversation-export');

  const tabs = [
    {
      id: 'conversation-export',
      name: 'Conversation Export',
      icon: DocumentArrowDownIcon,
      component: ConversationExport,
    },
    // Future tabs can be added here
    // {
    //   id: 'usage-analytics',
    //   name: 'Usage Analytics',
    //   icon: ChartBarIcon,
    //   component: UsageAnalytics,
    // },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Analytics</h1>
        <p className="text-gray-600">Export and analyze conversation data</p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`${
                  activeTab === tab.id
                    ? 'border-[#075e54] text-[#075e54]'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2`}
              >
                <IconComponent className="h-5 w-5" />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-lg shadow">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Analytics;
